import React from "react";

export const MinimalCrashPage: React.FC = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      fontFamily: "sans-serif",
      textAlign: "center",
      padding: "0 40px",
    }}
  >
    <h1 style={{ fontSize: "48px", fontWeight: 500, margin: "0 0 16px" }}>Something went wrong</h1>
    <p style={{ fontSize: "18px", maxWidth: "560px" }}>
      An unexpected error occurred. Please refresh the page to try again.
    </p>
  </div>
);
